import React from "react";
//import PropTypes from 'prop-types';

import Resources from "playground/cms/views/Resources";
import { FormLayout } from "playground/cms/Form";
import SyncTasksForm from "./SyncTasksForm";

export function SyncTasks(props) {
    const {} = props;
    return (
        <Resources {...props}>
            <FormLayout>
                <FormLayout.Content replace={true}>
                    <FormLayout.Tab
                        id={"sync-task"}
                        label={"Ustawienia synchronizacji"}
                    >
                        <SyncTasksForm {...props} />
                    </FormLayout.Tab>
                </FormLayout.Content>
            </FormLayout>
        </Resources>
    );
}

SyncTasks.propTypes = {};

SyncTasks.defaultProps = {};

export default SyncTasks;
